module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/hospital_list/img_doctor06-87f2a9d54c8b05211acbadd5439d1b44.png";